export default "__VITE_ASSET__BpRjpQnr__"